import React from 'react';

const Printer = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path">
          <path
            id="Rectangle_1052"
            fill="#fff"
            stroke="#707070"
            d="M0 0H24V24H0z"
            data-name="Rectangle 1052"
            transform="translate(1136 383)"
          />
        </clipPath>
      </defs>
      <g id="Mask_Group_94" clipPath="url(#clip-path)" data-name="Mask Group 94" transform="translate(-1136 -383)">
        <g id="Group_1987" data-name="Group 1987" transform="translate(1137 384)">
          <path
            id="Path_3106"
            d={`M19.708 17h-2.75a.458.458 0 0 1 0-.917h2.75a1.377 1.377
            0 0 0 1.375-1.375V8.292a1.377 1.377 0 0 0-1.375-1.375H2.292A1.377 1.377
            0 0 0 .917 8.292v6.417a1.377 1.377 0 0 0 1.375 1.375h2.75a.458.458
            0 1 1 0 .917h-2.75A2.294 2.294 0 0 1 0 14.708V8.292A2.294 2.294
            0 0 1 2.292 6h17.416A2.294 2.294 0 0 1 22 8.292v6.417A2.294 2.294 0 0 1 19.708 17z`}
            data-name="Path 3106"
            transform="translate(0 -.5)"
          />
          <path
            id="Path_3107"
            d="M13.958 20.917h-5.5a.458.458 0 1 1 0-.917h5.5a.458.458 0 1 1 0 .917z"
            data-name="Path 3107"
            transform="translate(-.667 -1.667)"
          />
          <path
            id="Path_3108"
            d="M13.958 18.917h-5.5a.458.458 0 0 1 0-.917h5.5a.458.458 0 0 1 0 .917z"
            data-name="Path 3108"
            transform="translate(-.667 -1.5)"
          />
          <path
            id="Path_3109"
            d="M10.292 16.917H8.458a.458.458 0 1 1 0-.917h1.833a.458.458 0 0 1 0 .917z"
            data-name="Path 3109"
            transform="translate(-.667 -1.333)"
          />
          <path
            id="Path_3110"
            d={`M17.375 6.417a.459.459 0 0 1-.458-.458V2.292A1.377 1.377
            0 0 0 15.542.917h-8.25a1.377 1.377 0 0 0-1.375 1.375v3.666a.458.458
            0 1 1-.917 0V2.292A2.294 2.294 0 0 1 7.292 0h8.25a2.294 2.294
            0 0 1 2.292 2.292v3.666a.459.459 0 0 1-.459.459z`}
            data-name="Path 3110"
            transform="translate(-.417)"
          />
          <path
            id="Path_3111"
            d={`M15.542 23.083h-8.25A2.294 2.294 0 0 1 5 20.792v-7.334A.459.459
            0 0 1 5.458 13h11.917a.459.459 0 0 1 .458.458v7.333a2.294 2.294
            0 0 1-2.291 2.292zm-9.625-9.166v6.875a1.377 1.377 0 0 0 1.375 1.375h8.25a1.377 1.377
            0 0 0 1.375-1.375v-6.875z`}
            data-name="Path 3111"
            transform="translate(-.417 -1.083)"
          />
        </g>
      </g>
    </svg>
  );
};
export default Printer;
